<template>
  <div class="loginColumns animated fadeInDown">
      <div class="row">
          <div class="col-md-6">
            <img src="/images/PragyaLogo.png" class="register-logo">
            <h2 class="font-bold">Create your Pragya Account</h2>

            <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.
            </p>
          </div>
          <div class="col-md-6">
              <div class="ibox-content">
                  <form class="m-t" role="form">
                      <div class="form-group">
                          <input type="email" class="form-control" placeholder="Email" required="">
                      </div>
                      <div class="form-group">
                          <input type="password" class="form-control" placeholder="Password" required="">
                      </div>
                      <div class="form-group">
                          <input type="text" class="form-control" placeholder="First Name" required="">
                      </div>
                      <div class="form-group">
                          <input type="text" class="form-control" placeholder="Last Name" required="">
                      </div>
                      <button type="submit" class="btn btn-primary block full-width m-b">Create Account</button>

                      <p class="text-muted text-center">
                          <small>Already an Pragya Account?</small>
                      </p>
                      <b-link class="btn btn-sm btn-white btn-block" :to="{ name: 'login' }">Login</b-link>
                  </form>
              </div>
          </div>
      </div>
      <hr/>
      <div class="row">
          <div class="col-md-6">
              Pragya Inc.
          </div>
          <div class="col-md-6 text-right">
             <small>© 2019</small>
          </div>
      </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'register',
  props: [],
  components: {
  },
  data: () => {
    return {
    }
  },

  mounted () {
    this.loadUserTrack()
  },

  methods: {
    ...mapActions([
    ]),

    loadUserTrack () {
    }
  },

  computed: {
  },

  watch: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/login/components/Register.vue